export enum InvoiceType {
  Customer = 'CUSTOMER',
  Fleet = 'FLEET'
}
